<template>
  <b-row>
    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
    >
      <template #button-content>
        <b-row>
          <b-col
            cols="12"
            class="d-flex justify-content-end pr-3"
          >
            <div class="d-sm-flex d-none user-nav">
              <div class="d-flex flex-column justify-content-end align-items-end">
                <h4
                  class="user-name align-items-center d-flex font-weight-bolder mb-0 text-black"
                >
                  {{
                    !isOnlyKomcards ? $store.state.auth.userData.full_name ||
                      $store.state.auth.userData.username : profile.partner_business_name
                  }}
                </h4>
                <div
                  id="highest-level-badge"
                  class="highest-level-badge d-flex align-items-center cursor-pointer mt-25"
                  @click.stop
                >
                  <img
                    v-if="highestLevel.icon"
                    :src="highestLevel.icon"
                    class="level-badge-icon mr-25 !shadow-none"
                    :alt="highestLevel.name"
                  >
                  <span class="user-level-text font-small-2 font-weight-bold text-secondary">
                    {{ highestLevel.name === 'Regular' ? 'Reguler' : highestLevel.name }}
                  </span>
                </div>
                <b-popover
                  target="highest-level-badge"
                  triggers="hover"
                  placement="bottomleft"
                  custom-class="popover-level-user"
                >
                  <div
                    class="popover-level-user-container"
                    :class="{ 'scrollable': sortedProducts.length > 5 }"
                  >
                    <div
                      v-for="(item, index) in sortedProducts"
                      :key="item.product || index"
                      class="product-level-row d-flex align-items-center justify-content-between"
                      :class="{ 'mb-75': index < sortedProducts.length - 1 }"
                      :title="item.message || ''"
                    >
                      <div class="d-flex align-items-center mr-1">
                        <img
                          v-if="item.product_icon || item.logo_url || item.product_logo_url"
                          :src="item.product_icon || item.logo_url || item.product_logo_url"
                          class="product-logo mr-50"
                          :alt="item.product || 'logo'"
                        >
                        <span class="product-name text-capitalize">
                          {{ item.product_name || formatProductName(item.product) }}
                        </span>
                      </div>
                      <img
                        v-if="item.level_img_url"
                        :src="item.level_img_url"
                        class="level-badge-icon ml-auto"
                        :alt="item.level || 'badge'"
                        :title="item.level || 'badge'"
                      >
                    </div>
                  </div>
                </b-popover>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-avatar
          size="40"
          :src="$store.state.auth.userData.photo_profile_url"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <feather-icon
            v-if="!$store.state.auth.userData.photo_profile_url"
            icon="UserIcon"
            size="22"
          />
        </b-avatar>
      </template>
      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="skin = isDark ? 'light' : 'dark'"
      >
        <feather-icon
          size="16"
          :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
          class="mr-50"
        />
        <span>{{ isDark ? 'Light' : 'Dark' }} Mode</span>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="logout"
      >
        <feather-icon
          size="16"
          icon="LogOutIcon"
          class="mr-50"
        />
        <span>Logout</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <div class="mr-3 ml-50">
      <b-button
        size="sm"
        variant="flat-primary"
        class="btn-icon position-relative"
        @click="showNotification"
      >
        <b-img
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/notification-1.svg"
        />
        <div
          v-if="unreadCount > 0"
          class="wrapper-notification-count"
        >
          <span class="text-white font-semibold">{{ unreadCount }}</span>
        </div>
      </b-button>
      <b-modal
        id="modal-notification"
        ref="modal-notification"
        modal-class="myclass"
        hide-footer
        hide-header
        @show="setupNotificationObserver"
      >
        <b-row class="p-1 justify-content-between align-items-center mx-2">
          <div>
            <h4 class="text-black">
              <strong>
                Notifikasi
              </strong>
            </h4>
          </div>
          <div class="d-flex align-items-center">
            <b-button
              size="sm"
              :variant="unreadCount > 0 ? 'flat-primary' : 'flat-secondary'"
              class="ml-2 text-sm font-semibold bg-transparent border-0 shadow-0"
              :disabled="unreadCount === 0"
              @click="readAllNotification"
            >
              Tandai Baca Semua
            </b-button>
            <b-img
              src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
              class="cursor-pointer ml-1"
              @click="$bvModal.hide('modal-notification')"
            />
          </div>
        </b-row>
        <div
          ref="notificationObserver"
          class="wrapper-content-notification"
        >
          <b-row
            v-for="(item, index) in listNotification"
            :key="index + 1"
            spinner-variant="primary"
            :show="loadingNotification && !loadingNextLine"
            :style="
              item.is_read === 0
                ? 'background: #FFECE9; margin-left: -19px; margin-right: -19px; border-top: 1px solid #C2C2C2;'
                : 'background: white; margin-left: -19px; margin-right: -19px; border-top: 1px solid #C2C2C2;'
            "
            class="p-[2rem] cursor-pointer"
            @click="readNotif(item)"
          >
            <b-col cols="2">
              <b-img :src="item.image_path" />
            </b-col>
            <b-col
              cols="10"
              class="d-flex flex-column"
              style="width: 100%;"
            >
              <div
                class="d-flex justify-content-between align-items-center mb-1"
              >
                <span class="text-black font-semibold">
                  {{ item.title }}
                </span>
                <small
                  style="color: #626262;"
                  class="font-semibold"
                >
                  {{ getFormatDate(item.created_at) }}
                </small>
              </div>
              <small
                style="color: #626262;"
                v-html="item.description"
              />
            </b-col>
          </b-row>
          <p
            v-show="loadingNextLine"
            class="flex items-center justify-center gap-[5px] py-2 bg-light-primary rounded"
          >
            <b-spinner
              variant="primary"
              label="loading"
              small
            />Memuat notif
            lainnya...
          </p>
          <div
            ref="lastNotif"
            class="bottom-observer"
            style="height: 10px; width: 100%;"
          />
        </div>
        <div
          class="footer-notification-fixed w-full px-2 flex gap-4 sticky bottom-0 bg-white z-10 py-2"
        >
          <b-button
            variant="outline-primary"
            class="d-flex place-content-center items-center font-semibold !text-sm w-full grow !p-2"
            @click="showAllNotification"
          >
            Tampilkan Semua Pesan
          </b-button>
          <b-button
            :variant="unreadCount === 0 ? 'secondary' : 'primary'"
            class="d-flex w-full place-content-center items-center font-semibold !text-sm grow !p-2"
            :disabled="unreadCount === 0"
            @click="sortNotificationByUnread"
          >
            Pesan Belum Dibaca
            <span
              v-if="unreadCount > 0"
              class="badge badge-pill bg-[#FCD4BE] text-primary ml-1"
            >{{ unreadCount }}</span>
          </b-button>
        </div>
      </b-modal>
      <ModalFormRejected
        id="modal-form-rejected-by-notif"
        :modal="formRejectedModalData"
        @on-confirm="handleFormRejectedRedirect"
        @hidden="formRejectedModalData = {}"
      />
    </div>
  </b-row>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BSpinner,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import { avatarText } from '@core/utils/filter'
import { mapState } from 'vuex'
import store from '@/store'
import moment from 'moment'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { isUserLoggedIn, removeLocalStorageLogout } from '@/auth/utils'
import { newAxiosIns } from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import ModalFormRejected from '@/views/pages/komads/components/ModalFormRejected.vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BSpinner,
    ModalFormRejected,
  },
  data() {
    return {
      avatarText,
      listNotification: [],
      moment,
      level: '',
      icon: '',
      message: '',
      formRejectedModalData: {},
      isTopLevel: false,
      ExpiredWhatsapp: 0,
      user: this.$store.state.auth.userData,
      levels: [],
      unreadCount: 0,
      loadingNotification: false,
      loadingNextLine: false,
      notificationObserver: undefined,
      limits: 10,
      offset: 0,
      lastData: false,
    }
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
  computed: {
    username() {
      const {
        is_komads, is_komchat, is_kompack, is_komship, is_komcards, partner_business_name, user_fullname,
      } = this.profile

      const otherFlags = [is_komads, is_komchat, is_kompack, is_komship]

      const isOnlyKomcards = is_komcards === 1 && otherFlags.every(flag => flag === 0)

      if (isOnlyKomcards) {
        return partner_business_name !== null ? partner_business_name : user_fullname
      }

      return user_fullname
    },
    isAdmin() {
      return isUserLoggedIn() && this.user.role_name?.toUpperCase() === 'ADMIN'
    },
    isOnlyKomcards() {
      return Object.entries(this.user).every(
        ([key, value]) => (key === 'is_komcards' ? value === true : value === false),
      )
    },
    profileRoute() {
      if (!isUserLoggedIn()) return ''
      if (this.user.role_name?.toUpperCase() === 'SDM') return 'talent-profile'
      if (this.user.role_name?.toUpperCase() === 'PARTNER') return 'partner-profile'
      return ''
    },
    greetingsTime() {
      const date = new Date()
      let dateChange = null
      let str = ''
      if (date.getUTCHours() - date.getHours() !== 0) {
        dateChange = date.getHours()
      } else {
        dateChange = 8 + date.getHours()
      }
      if (dateChange < 4) {
        str = 'Selamat Malam,'
      } else if (dateChange < 11) {
        str = 'Selamat Pagi,'
      } else if (dateChange < 16) {
        str = 'Selamat Siang,'
      } else if (dateChange < 20) {
        str = 'Selamat Sore,'
      } else {
        str = 'Selamat Malam,'
      }
      return str
    },
    sortedProducts() {
      const levelWeights = {
        saudagar: 3,
        juragan: 2,
        regular: 1,
      }

      const getTimestamp = item => {
        if (!item) return null
        if (item.joined_at_ts !== undefined && item.joined_at_ts !== null && item.joined_at_ts !== '') {
          let ts = Number(item.joined_at_ts)
          if (!Number.isNaN(ts)) {
            if (ts < 1e11) ts *= 1000
            return ts
          }
        }
        const dateField = item.joined_at || item.registered_at || item.created_at
        if (dateField) {
          if (!Number.isNaN(Number(dateField)) && !String(dateField).includes('-') && !String(dateField).includes('/')) {
            let ts = Number(dateField)
            if (ts < 1e11) ts *= 1000
            return ts
          }
          const d = new Date(dateField).getTime()
          if (!Number.isNaN(d)) return d
        }
        return null
      }

      const list = Array.isArray(this.levels) ? [...this.levels] : []
      return list.sort((a, b) => {
        const weightA = levelWeights[String(a.level || '').trim().toLowerCase()] || 0
        const weightB = levelWeights[String(b.level || '').trim().toLowerCase()] || 0
        if (weightB !== weightA) {
          return weightB - weightA
        }

        const timeA = getTimestamp(a)
        const timeB = getTimestamp(b)
        if (timeA !== null && timeB !== null) {
          if (timeA !== timeB) {
            return timeA - timeB
          }
        } else if (timeA !== null) {
          return -1
        } else if (timeB !== null) {
          return 1
        }

        const nameA = String(a.product || a.product_name || '')
        const nameB = String(b.product || b.product_name || '')
        return nameA.localeCompare(nameB)
      })
    },
    highestLevel() {
      if (!this.sortedProducts || this.sortedProducts.length === 0) {
        return {
          name: 'Regular',
          icon: '',
        }
      }
      const top = this.sortedProducts[0]
      const rawLevel = String(top.level || '').trim()
      const formattedLevel = rawLevel
        ? rawLevel.charAt(0).toUpperCase() + rawLevel.slice(1).toLowerCase()
        : 'Regular'

      return {
        name: formattedLevel,
        icon: top.level_img_url || top.level_icon_url || top.icon || '',
      }
    },
    ...mapState('dashboard', ['profile', 'levelUser']),
    ...mapState('whatsapp', ['check_wa', 'dashboard_wa']),
  },
  watch: {
    levelUser: {
      immediate: true,
      handler(val) {
        if (val) {
          this.levels = val
        }
      },
    },
    '$store.state.auth.userData': {
      handler(val) {
        if (val) {
          this.fetchLevelUser()
        }
      },
    },
    $route: {
      handler() {
        if (isUserLoggedIn() && (!this.levels || this.levels.length === 0)) {
          this.fetchLevelUser()
        }
      },
    },
  },
  async mounted() {
    const token = useJwt.getToken()
    if (!token) return
    this.getListNotification()
    await this.fetchLevelUser()
  },
  beforeDestroy() {
    if (this.notificationObserver) {
      this.notificationObserver.disconnect()
      this.notificationObserver = undefined
    }
  },
  methods: {
    async fetchLevelUser() {
      const token = useJwt.getToken()
      if (!token) return
      try {
        await this.$store.dispatch('dashboard/getUpdateLevelUser')
        this.levels = this.levelUser || []
      } catch (e) {
        console.error('Gagal mendapatkan level user:', e)
      }
    },
    logout() {
      this.logoutAuthModule()
      this.logoutAndRedirectToLoginPage()
    },
    formatProductName(name) {
      if (!name) return ''
      const str = String(name).trim()
      if (str.toLowerCase() === 'rajaongkir') return 'Raja Ongkir'
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    formatPrice(value) {
      let val = 0
      if (value !== undefined) {
        val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    showNotification() {
      this.$refs['modal-notification'].show()
      this.ExpiredWhatsapp = this.dashboard_wa !== null ? this.dashboard_wa.whatsapp_expired_at : 0
    },
    async getListNotification() {
      this.loadingNotification = true

      const params = {
        limit: this.limits,
        offset: this.offset,
        is_unread: this.unreadNotif,
      }

      const list = newAxiosIns.get('komship/api/v1/notifications/list', {
        params,
      })
      const info = newAxiosIns.get('komship/api/v1/notifications/info')

      const [listData, infoData] = await Promise.all([list, info])
        .catch(() => {
          this.lastData = true
        })
        .finally(() => {
          this.loadingNotification = false
          this.loadingNextLine = false
        })

      if (!listData?.data?.data || listData.data.data.length === 0) {
        this.lastData = true
      } else if (this.listNotification.length > 0) {
        this.listNotification = [
          ...this.listNotification,
          ...listData.data.data,
        ]
      } else {
        this.listNotification = listData.data.data
      }
      this.unreadCount = infoData.data.data.unread_count
    },
    /**
     * Handle notification for marketplace order
     * @param {Object} data - the notification data
     */
    handleMarketplaceOrderNotif(data) {
      const query = {
        status: 'submitted',
      }
      if (data.title === 'Pengajuan Packing Gagal!') {
        query.status = 'submitted'
      }

      this.$router.push({ path: '/marketplace-transaction', query })
      this.$bvModal.hide('modal-notification')
    },
    async readNotif(data) {
      // Optimistic UI: Change is_read status to 1 before API call
      const notifIndex = this.listNotification.findIndex(
        item => item.id === data.id,
      )
      if (
        notifIndex !== -1
        && this.listNotification[notifIndex].is_read === 0
      ) {
        this.listNotification[notifIndex].is_read = 1
        this.unreadCount = Math.max(0, this.unreadCount - 1)
      }
      await this.$http_komship.post(`/v1/notification/read/${data.id}`).catch(() => {
        // Rollback ui
        if (notifIndex !== -1) {
          this.listNotification[notifIndex].is_read = 0
          this.unreadCount += 1
        }
      })

      if (data.notification_type === 'MarketplaceOrder') {
        this.handleMarketplaceOrderNotif(data)
        return
      }

      if (data.notification_type === 'withdrawal') {
        this.$refs['modal-notification'].hide()
        // this.$router.push({ path: `/keuangan/saldo/rincian/${data.reference_id}` }).catch(() => {})
        window.location.assign(`/keuangan/saldo/rincian/${data.reference_id}`)
      } else if (data.notification_type === 'WhatsappPremium') {
        this.$refs['modal-notification'].hide()
        if (
          this.ExpiredWhatsapp > 0
          && this.$route.name !== 'dashboard-whatsapp'
        ) {
          this.$router.push({
            name: 'dashboard-whatsapp',
            params: { modal: 'renew' },
          })
        } else if (
          this.ExpiredWhatsapp > 0
          && this.$route.name === 'dashboard-whatsapp'
        ) {
          this.$bvModal.show('modal-renew-subcription')
        } else if (
          this.ExpiredWhatsapp === 0
          && this.$route.name !== 'opsional-feature'
        ) {
          this.$router.push({
            name: 'opsional-feature',
            params: { modal: 'renew' },
          })
        } else if (
          this.ExpiredWhatsapp === 0
          && this.$route.name === 'opsional-feature'
        ) {
          this.$bvModal.show('modal-choose-wa')
        }
      } else if (data.notification_type === 'InvoiceKomtim') {
        this.$router.push(`/invoice/${data.reference_id}`)
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'verificationKTPRejected') {
        this.$router.push('/verification-ktp')
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'verificationKTPApproved') {
        // doing nothing
      } else if (data.notification_type === 'SubmissionKompack') {
        this.$router.push(`/riwayat-pengajuan/produk/${data.reference_id}`)
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'OutboundKompack') {
        this.$router.push('/history-pickup')
        this.$bvModal.hide('modal-notification')
      } else if (
        data.notification_type === 'komcardTransactions'
        || data.notification_type === 'komcardNotifications'
      ) {
        this.$router.push('/komcards')
        this.$bvModal.hide('modal-notification')
      } else if (data.notification_type === 'komadsNotifications') {
        const { reference_id } = data

        const isRedirect = this.handleKomadsWarnNotifRedirect(data)
        if (isRedirect) {
          this.$bvModal.hide('modal-notification')
          return
        }

        const {
          platform, adAccountType, status, whitelist_account_request_id,
        } = this.translateKomadsReferenceId(reference_id)

        if (['00', '99'].includes(status)) return // On Review or Unknown
        if (['01', '02'].includes(status)) { // On Process CPAS or Accepted
          this.handleKomadsSuccessStatus({ platform, adAccountType, whitelist_account_request_id })
        } else if (status === '03') { // Rejected
          this.handleKomadsRejectedStatus(whitelist_account_request_id)
        }

        this.$bvModal.hide('modal-notification')
      } else {
        this.$refs['modal-notification'].hide()
        window.location.assign(`/ticketing/detail/${data.reference_id}`)
      }
    },
    async readAllNotification() {
      // Save the original copy for rollback
      const originalNotifications = [...this.listNotification]

      // Optimistic update
      this.listNotification = this.listNotification.map(notif => ({
        ...notif,
        is_read: 1,
      }))
      this.unreadCount = 0

      try {
        await newAxiosIns.post('komship/api/v1/notifications/mark-as-read')
      } catch (error) {
        this.listNotification = originalNotifications
        this.unreadCount = originalNotifications.filter(
          notif => notif.is_read === 0,
        ).length
        this.$toast_error({
          message: 'Gagal membaca semua notifikasi',
        })
      }
    },
    sortNotificationByUnread() {
      this.offset = 0
      this.unreadNotif = true
      this.listNotification = []
      this.lastData = false
      this.getListNotification()
    },
    showAllNotification() {
      this.offset = 0
      this.unreadNotif = false
      this.listNotification = []
      this.lastData = false
      this.getListNotification()
    },
    setupNotificationObserver() {
      this.$nextTick(() => {
        if (this.$refs.lastNotif) {
          this.notificationObserver = new IntersectionObserver(
            entries => {
              if (entries[0].isIntersecting) {
                this.handleIntersection()
              }
            },
            {
              root: this.$refs.notificationObserver,
              rootMargin: '0px',
              threshold: 0.1,
            },
          )
          this.notificationObserver.observe(this.$refs.lastNotif)
        } else {
          setTimeout(() => {
            if (this.$refs.lastNotif) {
              this.setupNotificationObserver()
            }
          }, 100)
        }
      })
    },
    handleIntersection() {
      if (!this.loadingNextLine && !this.lastData) {
        this.loadingNextLine = true
        this.offset += this.limits
        setTimeout(() => {
          this.getListNotification()
        }, 1500)
      }
    },
    translateKomadsReferenceId(value) {
      if (!value) return []

      const str = String(value)
      const firstFour = str.slice(0, 4)
      const whitelist_account_request_id = str.slice(4)

      const status = firstFour.slice(-2)
      const [platform, adAccountType] = firstFour.slice(0, -2).split('')

      return {
        platform, // 1 = Meta, 2 = Google, 3 = TikTok, 9 = Unknown
        adAccountType, // 1 = CPAS, 2 = Whitelist, 0 = Unknown
        status, // 00 = On Review, 01 = On Process CPAS, 02 = Accepted, 03 = Rejected, 99 = Unknown
        whitelist_account_request_id,
      }
    },
    handleKomadsWarnNotifRedirect({ image_path }) {
      const imagePaths = image_path.split('/')
      const image = imagePaths[imagePaths.length - 1]
      if (image.includes('komads-calendar')) {
        const url = '/whitelisted-account'
        const params = new URLSearchParams()

        params.set('platform', 'google')

        const query = params.size ? `?${params.toString()}` : ''
        window.location.assign(url + query)
        return true
      }
      return false
    },
    handleKomadsSuccessStatus({ platform, adAccountType, whitelist_account_request_id }) {
      const PLATFORM_MAP = {
        1: 'meta',
        2: 'google',
        3: 'tiktok',
        9: '',
      }
      const url = '/whitelisted-account'
      const params = new URLSearchParams()

      const mappedPlatform = PLATFORM_MAP[platform]
      if (mappedPlatform) {
        params.set('platform', mappedPlatform)
      }
      if (platform === '1' && adAccountType === '1') {
        params.set('ad_account_type', 'cpas')
        params.set('wlid', whitelist_account_request_id)
      }

      const query = params.size ? `?${params.toString()}` : ''
      window.location.assign(url + query)
    },
    async handleKomadsRejectedStatus(whitelist_account_request_id) {
      try {
        const { data: { data } } = await newAxiosIns.get(`/komads/api/v1/whitelist_accounts/request/${whitelist_account_request_id}/detail`)
        this.formRejectedModalData = {
          description: data.notes,
          platform: data.platform_name,
          account_request_id: whitelist_account_request_id,
          ad_account_type: data.ad_account_type,
          has_partner_cpas_proof_url: data.partner_cpas_proof_url,
          claim_tier: data.gamification_claim?.claim_tier,
          claim_amount: data.gamification_claim?.spending_threshold,
        }
        this.$bvModal.show('modal-form-rejected-by-notif')
      } catch (error) {
        console.warn(error)
      }
    },
    handleFormRejectedRedirect() {
      const {
        platform, account_request_id, ad_account_type, has_partner_cpas_proof_url, claim_tier, claim_amount,
      } = this.formRejectedModalData

      const postMessage = {
        platform,
        account_request_id,
        ad_account_type,
        status: 'rejected',
        has_partner_cpas_proof_url,
        claim_tier,
        claim_amount,
      }

      this.$store.dispatch('komads/setWhitelistedPostMessage', postMessage)
      this.$bvModal.hide('modal-form-rejected-by-notif')
      window.location.assign('/whitelisted-account')
    },
    getFormatDate(value) {
      const pastDate = moment(value)
      const currentDate = moment(new Date())
      const asHours = moment.duration(currentDate.diff(pastDate))
      const hour = Math.round(asHours.asHours())
      const minutes = Math.round(asHours.asMinutes())
      let format = ''
      if (hour === 0) {
        format = `${minutes} menit yang lalu`
      }
      if (hour === 1 || hour > 1) {
        format = `${hour} jam yang lalu`
      }
      if (hour > 3 && hour < 24) {
        format = moment(new Date(value)).format('HH.mm')
      }
      if (hour >= 20 && hour <= 48) {
        format = `Kemarin ${moment(new Date(value)).format('HH.mm')}`
      }
      if (hour > 48) {
        format = `${moment(new Date(value)).format('DD MMMM YYYY HH.mm')}`
      }
      return format
    },
    logoutAndRedirectToLoginPage() {
      store.commit('dashboard/UPDATE_ِِMY_PROFILE', [])
      store.commit('dashboard/UPDATE_LEVEL_USER', [])
      this.levels = []

      this.$store.commit('komcards/UPDATE_VIEW_LIST', 'grid')

      removeLocalStorageLogout()

      // Reset ability
      this.$ability.update(initialAbility)

      // If embedded inside partner-v2 (React), we MUST tell the parent to clear its session.
      // Otherwise, the parent will keep the session alive and sync it back!
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'navigate', route: '/logout' }, '*')
      } else {
        // Hard redirect to login page for standalone mode
        window.location.href = '/login'
      }
    },
    logoutAuthModule() {
      return new Promise(resolve => {
        const iframe = document.createElement('iframe')
        iframe.src = `${process.env.VUE_APP_BASE_AUTH_MODULE}/logout`
        iframe.width = '0'
        iframe.height = '0'
        iframe.style.display = 'none'

        const onMessage = event => {
          if (event.data && event.data.type === 'logout-success') {
            window.removeEventListener('message', onMessage)
            resolve()
          }
        }
        window.addEventListener('message', onMessage)

        iframe.onerror = () => {
          window.removeEventListener('message', onMessage)
          resolve()
        }

        document.body.appendChild(iframe)

        // Fallback timeout just in case the React app fails to load or send the message
        setTimeout(() => {
          window.removeEventListener('message', onMessage)
          resolve()
        }, 5000)
      })
    },
  },
}
</script>
<style scoped>
::v-deep .myclass > .modal-dialog {
  position: unset;
  transform: none !important;
}
::v-deep .myclass > .modal-dialog > .modal-content {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  margin: 7rem 2rem;
}
::v-deep .myclass > .modal-dialog > .modal-content .modal-body {
  padding: 0px !important;
}
.wrapper-content-notification {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
}
.wrapper-notification-count {
  background: #f95031;
  height: 24px;
  min-width: 28px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -5px;
  right: -5px;
}
.icon-level {
  width: 32px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.footer-notification-fixed {
  width: 100%;
  left: 0;
}
.badge-pill {
  font-size: 12px;
}
/* Popover Level User */
::v-deep .popover-level-user {
  border: none !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  background: #ffffff !important;
}
::v-deep .popover-level-user .arrow {
  display: none !important;
}
::v-deep .popover-level-user .popover-body {
  padding: 12px 14px !important;
}
.popover-level-user-container {
  min-width: 155px;
}
.popover-level-user-container.scrollable {
  max-height: 168px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}
.popover-level-user-container.scrollable::-webkit-scrollbar {
  width: 4px;
}
.popover-level-user-container.scrollable::-webkit-scrollbar-track {
  background: transparent;
}
.popover-level-user-container.scrollable::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}
.product-level-row {
  min-height: 24px;
}
.product-logo {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}
.level-badge-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
}
.product-name {
  font-size: 12px;
  font-weight: 500;
  color: #222222;
  white-space: nowrap;
}
.highest-level-badge {
  line-height: 1;
}
.user-level-text {
  font-size: 12px;
  line-height: 1.2;
  color: #5e5873;
}
</style>
